module.exports = __webpack_public_path__ + "static/media/oeko-tex-logo.e6d7cc47.png";